<template>
    <div class="form">
        <div class="form-section">
            <div class="form-row">
                <div class="form-row__col">
                    <alert type="info">
                        {{ trans('course_variations.note.empty_fields') }}
                    </alert>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('course_variations.headline.course_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="variation_name"
                        :required="true"
                        v-model="fields.variationName"
                    >
                        {{ trans('course_variations.label.variation_name') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="title"
                        v-model="fields.title"
                        :placeholder="trans('course_variations.label.inherited')"
                    >
                        {{ trans('course_variations.label.title') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label">{{ trans('course_variations.label.tenant') }}</label>
                    <v-select id="tenant_select" v-model="selectedTenant"
                        :options="this.tenantSelectOptions"
                        @input="apiGetClients"
                        class="form-vue-select"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input type="hidden" name="tenant_ident" :value="selectedTenant.ident">
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <label class="label">{{ trans('course_variations.label.client') }}</label>
                    <v-select id="client_select" v-model="selectedClient"
                        :options="this.clientSelectOptions"
                        class="form-vue-select"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                    <input type="hidden" name="client_id" :value="selectedClient.value">
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="comment"
                        v-model="fields.comment"
                    >
                        {{ trans('course_variations.label.comment') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.description"
                        name="description"
                        :placeholder="trans('course_variations.label.inherited')"
                        :rows="10">
                        {{ trans('courses.label.description') }}
                    </form-text-area>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <label class="label" for="image_path">{{ trans('course_variations.label.image_path') }}</label>
                    <dropzone :uploaded-file="fields.imagePath" name="image_path" @change="onChange" @remove="onRemove">
                        {{ trans('courses.note.image_upload') }}
                    </dropzone>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('course_variations.label.assigned_learning_contents') }}
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <div class="icon-button icon-button--primary" @click.prevent="open">
                        <div class="icon-button__icon">
                            <img src="/images/icons/create.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <draggable v-model="learningContentsArray">
                        <transition-group>
                            <div
                                class="learning-content-assign"
                                v-for="(learning_content, index) in learningContentsArray"
                                :key="learning_content.id"
                            >
                                <div class="learning-content-assign-row">
                                    <div class=""> {{ index + 1 }}</div>

                                    <div class="learning-content-assign-row__name">
                                        <div class="learning-content-assign-row__flex-display">
                                            <div>{{learning_content.name}}</div>
                                            <div v-show="learning_content.comment">({{learning_content.comment}})</div>
                                        </div>

                                        <div class="" v-show="showDependency(learning_content)">
                                            {{trans('course_variations.learning_content.depend_on')}}: {{ learning_content.dependency_name }}
                                        </div>
                                    </div>


                                    <div class="">
                                        <button type="button" class="btn btn--secondary"
                                        @click="removeLearningContents(index, learning_content.id)"
                                        >
                                            {{ trans('buttons.remove') }}
                                        </button>
                                    </div>

                                    <!-- Add hidden input to send sync() infos -->
                                    <input
                                        type="text"
                                        :name="'learning_contents['+learning_content.id+'][order]'"
                                        :value="index + 1"
                                        hidden
                                    />
                                    <input
                                        type="text"
                                        :name="'learning_contents['+learning_content.id+'][dependency]'"
                                        :value="getDependency(learning_content)"
                                        hidden
                                    />
                                    <!-- Also add name/id/depenedency_name for $old attributes -->
                                    <input
                                        type="text"
                                        :name="'learning_contents_old[' + index + '][id]'"
                                        :value="learning_content.id"
                                        hidden
                                    />
                                    <input
                                        type="text"
                                        :name="'learning_contents_old[' + index + '][name]'"
                                        :value="learning_content.name"
                                        hidden
                                    />
                                    <input
                                        type="text"
                                        :name="'learning_contents_old[' + index + '][dependency_name]'"
                                        :value="learning_content.dependency_name"
                                        hidden
                                    />
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
            </diV>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('course_variations.headline.additional_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="instruction_period"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.instructionPeriod"
                        :placeholder="trans('course_variations.placeholders.instruction_period', {days: course.instruction_period})"
                    >
                        {{ trans('courses.label.instruction_period') }}
                    </form-input>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('course_variations.headline.certificate_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.is_certifiable"
                        name="is_certifiable"
                        :options="[
                            {value: null, label:trans('course_variations.label.inherit')},
                            {value: 1, label:trans('course_variations.label.true')},
                            {value: 0, label:trans('course_variations.label.false')},
                        ]"
                    >
                        {{ trans('course_variations.label.is_certifiable') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row" v-if="this.showCertificate">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.additionalInformation"
                        name="additional_information"
                        :rows="10"
                        :placeholder="fields.is_certifiable == null && this.course.is_certifiable ? trans('course_variations.label.inherited') : ''">
                        {{ trans('courses.label.additional_information') }}
                    </form-text-area>
                </div>
            </div>
        </div>

        <input v-model="deletedImage" id="deletedImage" name="deletedImage" type="hidden">

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: {
        'course' : {
            type: Object,
            default: () => { return {} }
        },
        'tenants' : {
            type: Array,
            default: []
        },
        'variation' : {
            type: Object,
            default: () => { return {} }
        },
    },

    data() {
        return {
            selectedTenant: {},
            selectedClient: {label: this.trans('course_variations.label.all'), value: null},
            clients: [],
            learningContentsArray: [],
            assignedLearningContentsIds: [],
            fields: {
                variationName: this.old('variation_name', this.variation.variation_name),
                title: this.old('title', this.variation.title),
                comment: this.old('comment', this.variation.comment),
                description: this.old('description', this.variation.description),
                imagePath: this.getImagePath(),
                instructionPeriod: this.old('instruction_period', this.variation.instruction_period),
                is_certifiable: this.old('is_certifiable', (this.variation.is_certifiable !== null) ? this.variation.is_certifiable : null),
                additionalInformation: this.old('additional_information', this.variation.additional_information),
                learningContents: this.getLearningContentField()
            },

            deletedImage: null
        };
    },

    computed: {
        tenantSelectOptions() {
            var temp = this.tenants.map(tenant => {
                return {label: tenant.tenant_name, value: tenant.id, ident: tenant.tenant_ident};
            });
            temp.unshift({label: this.trans('course_variations.label.all'), value: null, ident: null});
            return temp;
        },
        clientSelectOptions() {
            var temp = this.clients.map(client => {
                return {label: client.name, value: client.id};
            });

            temp.unshift({label: this.trans('course_variations.label.all'), value: null});

            return temp;
        },
        showCertificate() {
            return this.fields.is_certifiable == 1 || this.fields.is_certifiable == null && this.course.is_certifiable
        }
    },

    mounted() {
        // If submit button in assign modal is clicked, refresh following datas.
        EventBus.$on('submit', (data) => {
            this.fields.learningContents.push(data);
            this.assignedLearningContentsIds.push(data.id);
            this.learningContentsArray = this.fields.learningContents;
        })

        // Fetch all assigned learning contents ids
        this.getAssignedLearningContentsId();

        /**
         * Instead of using field.learningContents,
         * we set an learningContentsArray for draggable usage,
         * otherwise, it causes some vue errors.
         */
        this.learningContentsArray = this.fields.learningContents;


        this.presetDatabaseAndClient();
    },

    methods: {
        presetDatabaseAndClient() {
            let selectedTenant = this.tenants.filter((tenant) => {
                return tenant.tenant_ident == this.variation.tenant_ident;
            });

            if (!selectedTenant.length) {
                this.selectedTenant = {
                    label: this.trans('course_variations.label.all'),
                    value: null,
                    ident: null
                };
            } else {
                this.selectedTenant = {
                    label: selectedTenant[0].tenant_name,
                    value: selectedTenant[0].id,
                    ident: selectedTenant[0].tenant_ident,
                };

                var filtered_tenant = this.tenants.filter(tenant => {
                    return tenant.tenant_ident == this.variation.tenant_ident;
                });
                this.selected_tenant = {label: filtered_tenant[0].tenant_name, value: filtered_tenant[0].id, ident: filtered_tenant[0].tenant_ident};

                // also update the client select list
                axios.post('/api/clients/getClientsFromTenant', {'tenant_ident': this.selectedTenant.ident}).then(response => {
                    this.clients = response.data;

                    // if learning content has client_id in edit, overwrite the default
                    if (this.variation.client_id) {
                        var filteredClient = this.clients.filter(client => {
                            return client.id == this.variation.client_id;
                        });

                        this.selectedClient = {label: filteredClient[0].name, value: filteredClient[0].id};
                    }
                });
            }
        },

        getImagePath() {
            return this.old['image_path']
            ? '/storage/' + this.old['image_path']
            : (this.variation && this.variation['image_path'] ? '/storage/' + this.variation['image_path'] : '')
        },

        /**
         * Returns value of given field.
         */
        getValue(field, value = null, boolean = null) {
            if (!boolean) {
                return this.old[field] ? this.old[field] : (this.variation && this.variation[field] ? this.variation[field] : value);
            } else {
                return this.old[field] ? this.old[field] : (this.variation && this.variation[field] !== null ? this.variation[field] : value);
            }
        },

        /**
         * Get value of assigned learning contents.
         * By fetching old attribute, we have a specific feld 'learning_contents_old' for it.
         */
        getLearningContentField() {
            if (this.errors.length != 0) {
                if (this.errors.learning_contents != null) {
                    return this.variation['learning_contents']
                } else {
                    return this.old('learning_contents_old')
                }
            }
            return this.variation['learning_contents']
        },

        /**
         * Open the assign modal, send the already assigned props to it
         */
        open() {
            this.$modal.show(
                {
                    template: `
                    <main-learning-contents-assignment :learningContents="learningContents" @close="$emit('close')"></main-learning-contents-assignment>
                `,
                props: ['learningContents']
                },
                {
                    learningContents: this.assignedLearningContentsIds
                },
                {
                    height: 'auto',
                    width: '80%',
                    adaptive: true,
                    pivotY: 0.3,
                    scrollable: true,
                },
                {}
            );
        },

        /**
         * Loop all assigned learningContents and save them into an array. This array will be sent to Assign modal per props.
         */
        getAssignedLearningContentsId() {
            if (this.fields.learningContents.length) {
                this.fields.learningContents.forEach(element => {
                    this.assignedLearningContentsIds.push(element.id)
                });
            }
        },

        /**
         * Remove-function of learning contents,
         * also re-filter the assigned_learning_contents_id,
         * so that it can be selected again in the next opening assign modal.
         */
        removeLearningContents(index, id) {
            this.learningContentsArray.splice(index, 1);
            this.assignedLearningContentsIds = this.assignedLearningContentsIds.filter(item => item !== id);
        },

        /**
         * Show dependency name.
         * For new added learning contents, they don't have pivot, so instead, we fetch direct the dependency property.
         */
        getDependency(learning_content) {
            return (learning_content.pivot != null)
                    ?
                    learning_content.pivot.dependency
                    : learning_content.dependency
        },

        showDependency(learning_content) {
            return this.getDependency(learning_content) != null;
        },

        apiGetClients() {
            this.selectedClient = {
                label: this.trans('course_variations.label.all'),
                value: null,
            };

            if (this.selectedTenant.ident == null) {
                this.clients = [];
                return;
            }

            axios.post('/api/clients/getClientsFromTenant', {'tenant_ident': this.selectedTenant.ident}).then(response => this.clients = response.data);
        },

        /**
         * Method for the picture-input component
         * It is called if the image has been changed
         * this.deletedImage is set to null so we can be aware that the image has not been deleted in the controller
         */
        onChange() {
            this.deletedImage = null;
        },

        /**
         * Method for the picture-input component
         * It is called if the image has been removed
         * this.deletedImage is given a value so we can be aware that the image has been deleted in the controller
         */
        onRemove() {
            this.fields.imagePath = ''
            this.deletedImage = this.variation.image_path;
        }
    },
}
</script>
